import { gql } from '../../types/generated';

export const GET_SESSION_OVERRIDES = gql(`
  query sessionOverrides {
    sessionOverrides {
      id
      features
      matchParams
    }
  }
`);
